import { ApiStatus } from 'common/enums';
import {
    ComponentRegistryItemWithSubRoutes,
    FeatureActionsList
} from 'common/models/roles-and-access/roleAccess.model';
import { RootState } from 'common/redux/core/root.reducer';
import { getUserInfoSelector } from 'common/redux/user/user.selector';
import { getFeaturesAndActionsData } from 'common/utils/access-provider.utils';
import React, { ReactElement, createContext, useState, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

const RolesAndAccessContext = createContext<{
    featuresActions: FeatureActionsList;
    featuresHierarchy: ComponentRegistryItemWithSubRoutes[];
}>({
    featuresActions: [],
    featuresHierarchy: []
});
function AccessProvider({ children }: { children: ReactElement }) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    /** this is just a dummy data, replace it with actual data also need to remove above eslint disabled line*/
    // const isAuthReady = useLogin();
    const userInfo = useSelector((state: RootState) => getUserInfoSelector(state));

    const [rolesData, setRolesData] = useState<{
        featuresActions: FeatureActionsList;
        featuresHierarchy: ComponentRegistryItemWithSubRoutes[];
    }>({
        featuresActions: [],
        featuresHierarchy: []
    });
    const dispatch = useDispatch();
    useEffect(() => {
        if (userInfo?.status === ApiStatus.SUCCESS && userInfo?.data && userInfo?.data?.isValidUser)
            getFeaturesAndActionsData(dispatch, setRolesData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userInfo?.data]);
    return (
        <RolesAndAccessContext.Provider value={rolesData}>
            {children}
        </RolesAndAccessContext.Provider>
    );
}

export default AccessProvider;

export const useRolesAndAccess = () => useContext(RolesAndAccessContext);
